// variables
var page 					= "#page";
var sidebar 				= "#sidebar";
var search_header 			= "#search_input_box";
var productslist_navigation	= "#productslist_navigation";
var spinner 				='<div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div><div class="rect6"></div><div class="rect7"></div><div class="rect8"></div><div class="rect9"></div><div class="rect10"></div></div>';
var window_width			= window.innerWidth;
let anchorlinks 			= document.querySelectorAll('a[href^="#"]')

for (let item of anchorlinks) {
    item.addEventListener('click', (e) => {
        let hashval = item.getAttribute('href')
        if (!hashval || hashval === '#') {
            return
        }
        let target = document.getElementById(hashval.slice(1))
        if (!target) {
            return
        }
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        })
        history.pushState(null, null, hashval)
        e.preventDefault()
    })
}

//Encoding: UTF-8
$(document).ready(function() {

	// Moodbar
	$(".slick-slider.moodbar").slick({
		slidesToShow:	1,
		slidesToScroll:	1,
		autoplay:		true,
		autoplaySpeed:	4000,
		cssEase:		'ease-in-out',
		useTransform:	true,
		fade:			true,
		infinite:		true,
		lazyLoad:		'ondemand',
		dots:			true,
		arrows:			true,
		customPaging: function (slider, i) {
			var indexPadded = i < 10 ? '0' + i : i;
			return `
				<button
					id="navigation${indexPadded}"
					type="button"
					role="tab"
					aria-selected="false"
					aria-controls="slick-slide${indexPadded}"
					aria-label="Gehe zu Folie ${i + 1}"
				>
					${i + 1}
				</button>`;
		},
		nextArrow: '<button type="button" class="slick-next" aria-label="N&auml;chste Folie"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
		prevArrow: '<button type="button" class="slick-prev" aria-label="Vorherige Folie"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
	});

	// Cover Slider Detailpage
	$(".slick-slider.cover-slider").slick({
		slidesToShow:		1,
		slidesToScroll:	1,
		autoplay:				false,
		dots:						true,
		arrows:					false
	});

	// init chosen dropdowns
	init_chosen();

	// slowly scrolling to the top of the page
	$("#goto").on("click", function(e){
		$("html, body").animate({
			scrollTop:$('#header').offset().top
		},"slow");
		e.preventDefault();
	});

	// show button to go while scrolling the page
	$(window).scroll(function(){
		if($(window).scrollTop() > 150){
			// begin to scroll
			$("#goto").css("display","block");
			$("#goto").css("position","fixed");
			$("#goto").css("bottom","5%");
			$("#goto").css("right","5%");
		}
		else{
		// lock it back into place
		$("#goto").css("position","relative");
		$("#goto").css("display","none");
		}
	});

	init_svg_images();
	init_menu_overlay();
	init_menu_header_overlay();
	init_images();
	init_to_top_button();

	$('[data-toggle="popover"]').popover();

	// Collapse: toggle arrows
	$('.collapse')
	.on('show.bs.collapse', function() {
		var $this = $(this);
		if (!$this.hasClass('show')) {
			var $icon = $this.prev().find('.fa');
			$icon.removeClass('fa-angle-down');
			$icon.addClass('fa-angle-up');
		}
	})
	.on('hidden.bs.collapse', function() {
		var $this = $(this);
		if (!$this.hasClass('show')) {
			var $icon = $(this).prev().find('.fa');
			$icon.removeClass('fa-angle-up');
			$icon.addClass('fa-angle-down');
		}
	});
	// Entferne Error Class nach KLICK
	$(".error-line").click(function(){
		$(this).removeClass('error-line');
		$(".cr").removeClass('error-line');
	});
	// Für Target_blank HTML-konform
	$("a[rel=external]").attr("target","_blank");
	$("a[rel=top]").attr("target","_top");
	$("a[rel=self]").attr("target","_self");

	$(".mehrfachlizenzen-button").click(function(){
		$(".mehrfachlizenzen-liste").slideToggle("slow");
		$("#plus").toggleClass("fa-plus fa-minus");
	});
	$(".teamticket-heading").click(function(){
		var teamticket_box = $(this).closest(".teamticket-box");
		teamticket_box.find(".teamticket-content").stop(true,true).slideToggle("slow");
		teamticket_box.toggleClass("is-open");
		teamticket_box.find(".teamticket-toggle i").toggleClass("fa-plus fa-minus");
	});

	$(".beratung-toggle").click(function(){
		var $button = $(this);
		var $overlay = $button.siblings(".beratung-overlay");
		var opening = !$overlay.is(":visible");
		$button.attr("aria-expanded", opening);
		$overlay.stop(true, true).slideToggle("slow");
	});

	// Typeahead
	if ( window_width >= 768 ) {
		init_typeahead();
	}

	updatePrices();
});

/**
 * init svg images
 * */
function init_svg_images() {
	// SVGs durch inline SVG-Code ersetzen
	$('img.svg').each(function() {
		var $img 		= $(this);
		var img_id 		= $img.attr('id');
		var img_class 	= $img.attr('class');
		var img_url 	= $img.attr('src');

		jQuery.get(img_url, function(data) {
			// Get the SVG tag, ignore the rest
			var $svg = jQuery(data).find('svg');

			// Add replaced image's ID to the new SVG
			if(typeof img_id !== 'undefined') {
				$svg = $svg.attr('id', img_id);
			}
			// Add replaced image's classes to the new SVG
			if(typeof img_class !== 'undefined') {
				$svg = $svg.attr('class', img_class+' replaced-svg');
			}

			// Remove any invalid XML tags as per http://validator.w3.org
			$svg = $svg.removeAttr('xmlns:a');

			// Replace image with new SVG
			$img.replaceWith($svg);

		}, 'xml');
	});
}

/**
 * bind "chosen" plugin for customizing select boxes
 * */
function init_chosen() {
	$(".chosen-dropdown").chosen({
		width:						'100%'
		,disable_search:			true
		,inherit_select_classes:	true
	});
	$(".chosen-single > div b").html("<i class='fa fa-angle-down fa-lg'></i>");
}

/**
 * functions for navigation
 * */
function init_sidebar(){
	if ($(page).css("position") == "fixed") {
		close_sidebar();
	} else {
		$(page).css("position", "fixed");
		$(page).css("transform", "translate3d(-300px,0,0)");
		$(sidebar).css("transform", "translate3d(0px,0,0)");
		$(sidebar).css("display", "block");
	}
}

function close_sidebar(){
	$(page).css("position", "relative");
	$(page).css("transform", "translate3d(0px,0,0)");
	$(sidebar).css("transform", "translate3d(-300px,0,0)");
	$(sidebar).css("display", "none");
}

function open_submenu(nav_type, content_id) {
	var navigation = "";

	if (nav_type == 'sidebar') {
		navigation = sidebar;
	} else if (nav_type == 'subnavigation') {
		navigation = subnavigation;
	} else if (nav_type == 'productslist_navigation') {
		navigation = productslist_navigation;
	}

	/* open this menu and change arrows*/
	$(navigation + " .angle_down_" + content_id).addClass("hidden");
	$(navigation + " .angle_up_" + content_id).removeClass("hidden");
	$(navigation + " .submenu_" + content_id).slideDown("fast");
}

function close_submenu(nav_type, content_id) {
	var navigation = "";

	var submenu = " .submenu_" + content_id;
	if (nav_type == 'sidebar') {
		navigation = sidebar;
	} else if (nav_type == 'subnavigation') {
		navigation = subnavigation;
	}

	$(navigation + " .angle_up_" + content_id).addClass("hidden");
	$(navigation + " .angle_down_" + content_id).removeClass("hidden");
	$(navigation + submenu).slideUp("fast");
	/* close also submenues */
	$(navigation + submenu + " .submenu").slideUp("fast");
	$(navigation + submenu + " .fa-angle-up").addClass("hidden");
	$(navigation + submenu + " .fa-angle-right").removeClass("hidden");
}

function toggle_search() {
	var search_div = jQuery(search_header);

	if(search_div.is(":visible")){
		search_div.hide();
	} else {
		search_div.show();
	}
}

// lazy-loading
function init_images()
{
	// Lazy loading of images using jquery.unveil
	// Exceptions:
	// - whcaptcha
	// - swiper lazy load
	$(":not(.whcaptcha) img:not(.swiper-lazy)").unveil(20);
}

/**
 * lazy load after every ajax request
 * */
$(document).ajaxComplete(function(event,request, settings ) {
	init_images();
});


/**
 * show main menu overlays on click
 * **/
function init_menu_overlay(){
	var active_id = 0;

	var display_block = "";
	var overlays = ".header-navigation-overlay";
	var id = 0;

	var menu_overlay_mouseover = false;

	$(".header-navigation-menu").on("click", function(e){
		id			= $(this).data("overlay");
		node_tagname= $(this)[0].tagName;
		e.preventDefault();
		display_block = $("#header_navigation_overlay_" + id).css("display");
		if ( node_tagname == 'A' && (display_block == 'block' || display_block == undefined) ) {
			window.location.href = this.href;
			return false;
		} else if (node_tagname != 'A' && (display_block == 'block' || display_block == undefined)) {
			$(".menu-to-hover").removeClass("hovered");
			$(overlays).css("display", "none");
			return false;
		}
		$(".menu-to-hover").removeClass("hovered");
		$(overlays).css("display", "none");
		setTimeout(function ()
		{
			$("#header_navigation_overlay_" + id).css("display", "block");
			menu_overlay_mouseover = true;
		}, 10);

	}).on("mouseleave", function(){
		menu_overlay_mouseover = false;
		setTimeout(function ()
		{
			if (!menu_overlay_mouseover) {
				$("#header_navigation_overlay_" + id).css("display", "none");
			}
		}, 400);
	});

	$(overlays).on("mouseover", function(){
		$(this).css("display", "block");
		$("#header_menu_" + id).addClass("hovered");
		menu_overlay_mouseover = true;
	}).on("mouseleave", function(){
		menu_overlay_mouseover = false;
		setTimeout(function ()
		{
			if (!menu_overlay_mouseover) {
				$(overlays).css("display", "none");
				$("#header_menu_" + id).removeClass("hovered");
			}
		}, 400);
	});

	$(".header-navigation-overlay .close").on('click', function(e) {
		close_menu_overlay();
	});
}

function close_menu_overlay() {
	setTimeout(function(){
		$(".closing_menu_wrapper").remove();
	},10)
	$(".closing_menu_wrapper").remove();
	$(".menu-to-hover").removeClass("active-li");
	$(".header-navigation-menu.active").removeClass("active");
	$(".header-navigation-overlay").slideUp(100);
}

function init_menu_header_overlay(){
	var overlays = ".header-subnavigation-overlay";
	var id = 0;

	var menu_overlay_mouseover = false;

	$(".header-subnavigation-menu").on("mouseover", function(){
		if(!($('.check-overlay').css('display')=='none')){
			id = $(this).data("overlay");
			$(".header-subnavigation-menu").removeClass("hovered");
			$(overlays).css("display", "none");
			$("#header_subnavigation_overlay_" + id).css("display", "block");
			menu_overlay_mouseover = true;
		}
	}).on("mouseleave", function(){
		if(!($('.check-overlay').css('display')=='none')){
			menu_overlay_mouseover = false;
			setTimeout(function ()
			{
				if (!menu_overlay_mouseover) {
					$("#header_subnavigation_overlay_" + id).css("display", "none");
				}
			}, 500);
		}
	});

	$(overlays).on("mouseover", function(){
		if(!($('.check-overlay').css('display')=='none')){
			$(this).css("display", "block");
			$("a[data-overlay=" + id + "]").addClass("hovered");
			menu_overlay_mouseover = true;
		}
	}).on("mouseleave", function(){
		if(!($('.check-overlay').css('display')=='none')){
			menu_overlay_mouseover = false;
			setTimeout(function ()
			{
				if (!menu_overlay_mouseover) {
					$(overlays).css("display", "none");
					$("a[data-overlay=" + id + "]").removeClass("hovered");
				}
			}, 500);
		}
	});

}

/* decryptThis E-Mail Adresse entschlüsseln */
function decryptThis(s) {
	var n=0;
	var r="";
	for(var i=0;i<s.length;i++) {
		n=s.charCodeAt(i);
		if (n>=8364) {n = 128;}
		r += String.fromCharCode(n-(2));
	}
	return r;
}

/* decrypt_mail href Attribut entschlüsseln */
function decrypt_mail(element, email, params) {
	if (!params) var params = '';
	element.href = 'mailto:' + decryptThis(email) + params;
}

// Ein Onclick Event von GA triggern
function triggerAnalyticsEvent(name,type,behrsNummer,ga_vier_aktiv) {
	if ( cookiemanager.accepted_statistics ) {
		if ( ga_vier_aktiv == 1 ) {
			gtag('event', type, {
				'event_category': name,
				'event_label'	: behrsNummer
			});
		}
		ga('send','event',name,type,behrsNummer);
	}
}

function init_typeahead(){
	$('#search-input-box input').unbind();

	$('#search-input-box input').each(function(){
		$(this).wh_typeahead({
			ajaxurl			: "/ajax/search"
			,top			: 50
			,right			: -80
			,container		: "#search-input-box"
			,width 			: 740
			,defaultstring	: ''
			,is_academy_page: $('#is_academy_page').val()
		});
	});
}

function init_to_top_button() {
	var a = $("#header").height();
	$(window).bind("scroll", function() {
		if ($(window).scrollTop() > a) {
			$(".totop-button").show();
		} else {
			$(".totop-button").hide();
		}
	});
	// Slowly scrolling to the top of the page
	$(".totop-button").click(function(e){
		$("html, body").animate({
			scrollTop: $("#header").offset().top
		},"slow");
	});
}

function close_banner_button() {
	$.ajax({
		type: 'GET'
		,url: '/ajax/set_banner_session'
		,cache: false
		,success: function(xml,textStatus) {}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {}
	});
	$('#pre-banner').slideUp('slow');
}

/**
 * accept specific cookies in whcookiemanager
 * will reload the page after the cookie has been updated in whCookieManager
 *
 * @consent_type	[string] (marketing|statistics) type of cookies which should be set
 */
function accept_specific_cookies(consent_type) {
	if (typeof cookiemanager !== 'undefined') {
		switch (consent_type) {
			case 'marketing':
			case 'statistics':
				// add eventlistener to verify that the cookie has been updated
				cookiemanager_el = document.getElementById('whCookieManager');
				cookiemanager_el.addEventListener('cookie_changed', (e) => {
					// reload the page
					window.location.reload();
				});
				// update the cookie
				cookiemanager.set_specific_cookie(consent_type);
			break;
		}
	}
}

function toggleShowMore(id = "", showMoreId = "", showLessId = "") {
    var currentActiveProgram = id;

    // Do a lookup for select if exists
    if (showMoreId === "show-more-programm") {
        var dropdowns = document.querySelectorAll('[id=seminar-dropdown]');
        if (dropdowns.length > 0) {
            var selectedValue = isParentElementHidden(dropdowns[0]) ? dropdowns[1].value : dropdowns[0].value;
            currentActiveProgram = `program-${selectedValue}`;
        }
    }

    // Toggle program content
    var textRest = document.querySelectorAll(`[id=${currentActiveProgram}]`);
    for (var i = 0; i < textRest.length; i++) {
        textRest[i].hidden = !textRest[i].hidden;
    }

    // Determine which button to show
    var showMoreButton = document.querySelectorAll(`[id=${showMoreId}]`);
    var targetShowMoreButton = isParentElementHidden(showMoreButton[0]) ? showMoreButton[1] : showMoreButton[0];

    var showLessButton = document.querySelectorAll(`[id=${showLessId}]`);
    var targetShowLessButton = isParentElementHidden(showLessButton[0]) ? showLessButton[1] : showLessButton[0];

    // Show/hide buttons so only one is visible at a time
    if (targetShowMoreButton.hidden) {
        targetShowMoreButton.hidden = false;
        targetShowLessButton.hidden = true;
    } else {
        targetShowMoreButton.hidden = true;
        targetShowLessButton.hidden = false;
    }
}

/**
 * Toggle the shortened and complete product description.
 *
 * The continue-reading custom tag renders the shortened version with the
 * suffix `_show_less` and the complete version under the plain text id.
 */
function toggle_more_description(textId = "") {
	var shortDescription = document.getElementById(`${textId}_show_less`);
	var fullDescription = document.getElementById(textId);

	if (!shortDescription || !fullDescription) {
		return;
	}

	var showFullDescription = fullDescription.classList.contains("d-none");
	shortDescription.classList.toggle("d-none", showFullDescription);
	fullDescription.classList.toggle("d-none", !showFullDescription);
}

function toggle_product_contributors(trigger) {
	var hiddenContributors = document.getElementById("product-contributors-more");
	if (!hiddenContributors || !trigger) {
		return false;
	}

	var showAllContributors = hiddenContributors.classList.contains("d-none");
	var label = trigger.querySelector(".product-detail-redesign__contributors-toggle-label");
	var icon = trigger.querySelector(".chevron-icon-text");
	hiddenContributors.classList.toggle("d-none", !showAllContributors);
	if (label) {
		label.textContent = showAllContributors ? "Weniger anzeigen" : "Alle anzeigen";
	}
	if (icon) {
		icon.classList.toggle("fa-angle-double-down", !showAllContributors);
		icon.classList.toggle("fa-angle-double-up", showAllContributors);
	}
	trigger.setAttribute("aria-expanded", showAllContributors ? "true" : "false");
	return false;
}

function open_product_information_tab(tabTitle = "") {
	var sections = document.querySelectorAll(".product-detail-redesign__sections details");
	var targetSection = Array.prototype.find.call(sections, function (section) {
		var summary = section.querySelector("summary");
		return summary && summary.textContent.trim() === tabTitle;
	});

	if (!targetSection) {
		return false;
	}

	targetSection.open = true;
	targetSection.parentElement.scrollIntoView({ behavior: "smooth", block: "start" });
	return false;
}

document.addEventListener("click", function (event) {
	var link = event.target.closest("a[title='Leistung']");
	if (link) {
		event.preventDefault();
		open_product_information_tab("Leistung");
	}
});


function hideAllPrograms(showMoreId = "", showLessId = "") {
	// We need to close/open, hide/show the all elements bcs we have multiple elements with the same id for responsive design
	var textRest = document.querySelectorAll(`[id^="program-"]`)
	for (var i = 0; i < textRest.length; i++) {
		textRest[i].hidden = true;
	}

	var showMoreButton = document.querySelectorAll(`[id=${showMoreId}]`)
	for (var i = 0; i < showMoreButton.length; i++) {
		showMoreButton[i].hidden = false;
	}

	var showLessButton = document.querySelectorAll(`[id=${showLessId}]`)
	for (var i = 0; i < showLessButton.length; i++) {
		showLessButton[i].hidden = true;
	}
}

function toggleSeminarDetails(id = '') {
	var chevronIcon = document.querySelectorAll(`[id=appointmentChevronIcon${id}]`);
	var appointmentDescription = document.querySelectorAll(`[id=appointmentDescription${id}]`);
 	$(".termin-status-header" + id).toggleClass('active');
	for (var i = 0; i < chevronIcon.length; i++) {
		if (chevronIcon[i].classList.contains('fa-angle-double-down')) {
			chevronIcon[i].classList.remove('fa-angle-double-down');
			chevronIcon[i].classList.add('fa-angle-double-up');
			appointmentDescription[i].hidden = false;
		} else {
			chevronIcon[i].classList.remove('fa-angle-double-up');
			chevronIcon[i].classList.add('fa-angle-double-down');
			appointmentDescription[i].hidden = true;
		}
	}
}

function changeProgram () {
	var dropdowns = document.querySelectorAll('[id=seminar-dropdown]');
	var selectedValue = isParentElementHidden(dropdowns[0]) ? dropdowns[1].value : dropdowns[0].value;

	// Update program
	var programDivs = document.querySelectorAll('[id^="program-"]');
    var container = document.querySelectorAll("#container-program");
	if (container) {
		container.forEach(function(container) {
			container.classList.remove("expanded");
		});
	}
	programDivs.forEach(div => {
        if (div.id === `program-${selectedValue}`) {
            div.style.display = 'block'; // Show the selected program
        } else {
            div.style.display = 'none'; // Hide other programs
        }
    });

	// Update program container height
	toggleSpanVisibility();

	// Update prices in info box
	updatePrices();
}

function updatePrices() {
	var dropdowns = document.querySelectorAll('[id=seminar-dropdown]');
	if (dropdowns.length > 0) {
		var selectedValue = isParentElementHidden(dropdowns[0]) ? dropdowns[1].value : dropdowns[0].value;
		var priceSpans = document.querySelectorAll('[id^="price-"]');
		var vatSpans = document.querySelectorAll('[id^="vat-"]');
		var daysSpans = document.querySelectorAll('[id^="days-"]');
		var subscribeButtons = document.querySelectorAll('[id^="button-subscribe-"]');
		var teamticketBoxes = document.querySelectorAll('.teamticket-child');

		priceSpans.forEach(span => {
			span.style.display = span.id === `price-${selectedValue}` ? 'block' : 'none';
		});
		vatSpans.forEach(span => {
			span.style.display = span.id === `vat-${selectedValue}` ? 'block' : 'none';
		});
		daysSpans.forEach(span => {
			span.style.display = span.id === `days-${selectedValue}` ? 'block' : 'none';
		});
		subscribeButtons.forEach(span => {
			span.style.display = span.id === `button-subscribe-${selectedValue}` ? 'block' : 'none';
		});
		teamticketBoxes.forEach(box => {
			box.style.display = box.dataset.teamticketChild === selectedValue ? 'block' : 'none';
		});
	}
}

function isParentElementHidden(element) {
	if (!element) {
		return true;
	}

	var firstParent = element.closest('.d-lg-none');

	// Ensure the parent exists before calling getComputedStyle on it
	if (firstParent) {
		var isLgInlineActive = window.getComputedStyle(firstParent).display;

		// Check if the display is set to 'none', meaning it's hidden
		return isLgInlineActive === 'none';
	}
	return false;
}

function scrollToElementTermine()	{
	var elements = document.querySelectorAll('[id^="termine"]');
	if (elements.length > 0) {
		var parentElement = isParentElementHidden(elements[0]) ? elements[1] : elements[0];
		parentElement.scrollIntoView({behavior: "smooth"});
	}
}

function toggleSpanVisibility() {
    var container = document.querySelectorAll("#container-program");
    var showMoreSpan = document.querySelectorAll("#show-more-programm");
    var showLessSpan = document.querySelectorAll("#show-less-programm");
    var programFade = document.querySelectorAll(".program-fade");
    if (container.length && showMoreSpan.length) {
		var threshold = window.innerWidth < 767 ? 355 : 750;
		// The desktop and mobile variants are not always rendered together.
		// Guard each entry before reading offsetHeight so pages with only one
		// responsive container do not throw a TypeError.
		var firstContainerHeight = container[0] ? container[0].offsetHeight : 0;
		var secondContainerHeight = container[1] ? container[1].offsetHeight : 0;
		var isContainerWithinLimit = (firstContainerHeight !== 0 && firstContainerHeight < threshold) || (secondContainerHeight !== 0 && secondContainerHeight < threshold);
        showMoreSpan.forEach(function(button) {
			if (isContainerWithinLimit) {
				button.classList.add("hidden");
			} else {
				button.classList.remove("hidden");
				button.classList.add("visible");
			}
		});
        showLessSpan.forEach(function(button) {
			if (isContainerWithinLimit) {
				button.classList.add("hidden");
			}
		});
        programFade.forEach(function(button) {
			if (isContainerWithinLimit) {
				button.classList.add("hidden");
			} else {
				button.classList.remove("hidden");
				button.classList.add("visible");
			}
		});
    }
}

document.addEventListener("DOMContentLoaded", function () {
	toggleSpanVisibility();
	var tabContainer = document.querySelector(".product-detail-redesign__sections");
	if (tabContainer) {
		var syncProductTabs = function () {
			var sections = tabContainer.querySelectorAll("details");
			var tabs = tabContainer.querySelectorAll(".product-detail-redesign__desktop-tabs button");
			tabs.forEach(function (tab, index) {
				tab.classList.toggle("is-active", !!sections[index] && sections[index].open);
			});
		};
		new MutationObserver(syncProductTabs).observe(tabContainer, { attributes: true, subtree: true, attributeFilter: ["open"] });
		tabContainer.addEventListener("click", function (event) {
			if (event.target.closest(".product-detail-redesign__desktop-tabs button")) {
				window.setTimeout(syncProductTabs, 0);
			}
		});
		window.setTimeout(syncProductTabs, 0);
	}
});

function expandProgram(id) {
    let containers = document.querySelectorAll("#container-program");
    let fadeEffects = document.querySelectorAll(".program-fade");
    let showMoreButtons = document.querySelectorAll("#show-more-programm");
    let showLessProgram = document.querySelectorAll("#show-less-programm");

    containers.forEach(function(container) {
        container.classList.add("expanded");
    });

    fadeEffects.forEach(function(fadeEffect) {
        fadeEffect.classList.add("hidden");
    });

    showMoreButtons.forEach(function(button) {
        button.classList.add("hidden");
    });

	showLessProgram.forEach(function(button) {
		button.classList.remove("hidden");
		button.classList.add("visible");
	});
}

function collapseProgram() {
	let containers = document.querySelectorAll("#container-program");
	let fadeEffects = document.querySelectorAll(".program-fade");
	let showMoreButtons = document.querySelectorAll("#show-more-programm");
	let showLessProgram = document.querySelectorAll("#show-less-programm");

	containers.forEach(function(container) {
		container.classList.remove("expanded");
	});

	fadeEffects.forEach(function(fadeEffect) {
		fadeEffect.classList.remove("hidden");
	});

	showMoreButtons.forEach(function(button) {
		button.classList.remove("hidden");
	});

	showLessProgram.forEach(function(button) {
		button.classList.add("hidden");
		button.classList.remove("visible");
	});

	// Scroll to the top of the Program section
	var elements = document.querySelectorAll('[id^="main-content"]');
	elements.forEach(function(element) {
		element.scrollIntoView({behavior: "smooth"});
	});
}
